import { connect } from 'react-redux';
import TssLink from 'Common/Map/OpenLayers/Tss/TssLink';
import {
    ILinkMaps, ILinkGeometries, INodes, IDetectorMaps,
    IDetectors, ILanePollData
} from "Store/index";
import {
    Link, OpStatus, LinkGeometry, Node,
    DetectorMap, DetectorConfig, Id
} from "NSwag/ServerClient/Client.nswag";
import Util from 'Util/index';
import { ILinkMap } from "DataLibrary/Tss/ILinkMap";
import { Action, Dispatch } from "redux/index";

interface IState {
    detectors: IDetectors,
    detectorMaps: IDetectorMaps,
    linkGeometries: ILinkGeometries,
    linkMaps: ILinkMaps,
    lanePollData: ILanePollData,
    nodes: INodes
}

interface IProps {
    link: Link,
    zoomLevel: number
}

/**
 * Maps the state to the props
 * @param {state} - current state
 * @param {props} - properies of the component
 */
const mapStateToProps = (state: IState, ownProps: IProps) => {

    let linkId = Util.IdToString(ownProps.link.id!);
    let roadwayLinkId: Id = new Id({ ...ownProps.link.id! });
    roadwayLinkId.resourceType = "roadwayLink";
    let geometryId = Util.IdToString(roadwayLinkId);

    let linkGeometry: LinkGeometry | null = state.linkGeometries ?
        state.linkGeometries[geometryId] :
        null;
    let previousLinkGeometry: LinkGeometry | null = null;
    let nextLinkGeometry: LinkGeometry | null = null;
    let startNode: Node | null = null;
    let endNode: Node | null = null;

    let map: DetectorMap | undefined = Object.values(state.detectorMaps).find((d) =>
        d.links!.filter((l: Link) => Util.IdToString(l.id!) == linkId).length > 0
    )
    let detector: DetectorConfig | undefined;

    if (map) {
        detector = state.detectors[Util.IdToString(map.id!)];
    }

    if (linkGeometry != null && linkGeometry.startNode != null) {

        startNode = state.nodes[Util.IdToString(linkGeometry.startNode!.id)];
        endNode = state.nodes[Util.IdToString(linkGeometry.endNode!.id)];
    }

    if (state.linkMaps) {
        let linkMap = state.linkMaps[geometryId];
        if (linkMap) {
            if (linkMap.prevLink !== null)
                previousLinkGeometry = state.linkGeometries[linkMap.prevLink];
            if (linkMap.nextLink !== null)
                nextLinkGeometry = state.linkGeometries[linkMap.nextLink];
        }
    }

    let pollData: ILanePollData = {}
    ownProps.link.lanes &&
        ownProps.link.lanes.forEach(l => {
            if (state.lanePollData) {
                let laneKey = Util.IdToString(l.id!);
                let lanePollData = state.lanePollData[laneKey];
                if (lanePollData) {
                    pollData[laneKey] = lanePollData;
                }
            }
    })

    return ({
        link: ownProps.link,
        opStatus: detector ? detector.status!.opStatus : OpStatus.NULL,
        linkGeometry,
        previousLinkGeometry,
        nextLinkGeometry,
        startNode,
        endNode,
        pollData,
        zoomLevel: ownProps.zoomLevel,
        // We have to overide ownProps interface here because the parent map adds these properties
        map: (ownProps as any).map,
        google: (ownProps as any).google,
        vectorLayerSource: (ownProps as any).vectorLayerSource
    });
};

/**
 * 
 * @param {any} dispatch
 * @param {any} ownProps
 */
const mapDispatchToProps = (dispatch: Dispatch<Action>, ownProps: IProps) => ({
});

/**
 * Connect the state and props to the component TssLane
 * */
const TssLinkContainer = connect(
    mapStateToProps,
    mapDispatchToProps
)(TssLink);

/**
 * exports TssLaneContainer as the default
 */
export default TssLinkContainer;